<template>
  <div class="marker-action">
    <list-action-form
      ref="form"
      :ids="ids"
      :labels="labels"
      :route="route"
      :method="method"
      @submitted="toggle"
    >
      <input type="hidden" name="primary" :value="primary" />
      <portal :to="name">
        <typeahead
          name="suggest-primary"
          hidden-input-name="primary"
          :placeholder="placeholder"
          :src="src"
          @selected="onPrimarySelected"
        ></typeahead>
        <a
          :class="['btn', 'btn-lg', 'btn-secondary', { disabled: !primary }]"
          @click.prevent="submit"
        >
          {{ labels.button }}
        </a>
      </portal>
    </list-action-form>
  </div>
</template>

<script>
import ListAction from './ListAction.vue';
import { Typeahead } from 'vue-bootstrap';

/**
 * The Duplicate Archiver component.
 */
export default {
  components: {
    Typeahead
  },
  extends: ListAction,
  props: {
    placeholder: {
      type: String,
      default: 'Select primary'
    },
    name: {
      type: String,
      required: true,
      validator: value => ['duplicate-archiver'].indexOf(value) !== -1
    }
  },
  data() {
    return {
      primary: null,
      src: ''
    };
  },
  watch: {
    ids(ids) {
      this.src = '/entry/duplicates/autocomplete?selected=' + ids + '&name=';
    }
  },
  methods: {
    toggle() {
      this.$emit('reveal', this.name);
    },
    onPrimarySelected(result) {
      this.primary = result.id;
    }
  }
};
</script>

<style scoped>
.vue-portal-target .dropdown {
  display: inline-block;
  width: 25%;
}
</style>
